module.exports = __webpack_public_path__ + "static/img/chain.b8aa77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/chain.png
// module id = m41R
// module chunks = 0